var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.heading)?_c('h3',{staticClass:"stat_section--heading text-uppercase"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('div',{class:{'stat_section--grid columns is-multiline my-0': _vm.hasColumns}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }